import React from "react";
import HTML from '../assets/html.png';
import CSS from '../assets/css.png';
import JavaScript from '../assets/javascript.png';
import ReactImg from '../assets/react.png';
import Node from '../assets/node.png';
import GitHub from '../assets/github.png';
import Tailwind from '../assets/tailwind.png';
import Mongo from '../assets/mongo.png';
import Figma from '../assets/figmaa.jpg';
import c from "../assets/c.png";
import cpp from "../assets/c++.png";
import git from "../assets/git.png";
import jwt from "../assets/jwt.png";
import antd from "../assets/antd.png";
import redux from "../assets/redux.png";
import mui from "../assets/mui.png";
import oauth from "../assets/oauth.png";
import passport from "../assets/passport.png";
import unix from "../assets/unix.png";
import ejs from "../assets/ejs.png";
import bootstrap from "../assets/bootstrap.png";
import dsa from "../assets/dsa.png";
import express from "../assets/express.png";
import authh from "../assets/auth.png";



const Skills = () => {
  return (
   <div id="skills" className="w-full text-gray-300 bg-gradient-to-b from-black to-blue-900">
    <br/>
  <div className="max-w-5xl mx-auto p-4">
    <div className="text-center">
      <h1 className="text-4xl font-bold mb-4 inline-block my-16 text-yellow-300">My <span className="text-red-500">Skills</span></h1>
    </div>
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 py-8">
      <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
        <img className="w-20 mx-auto mt-4 mb-2" src={dsa} alt="HTML icon" />
        <p className="text-lg">DATA STRUCTURES AND ALGORITHM</p>
      </div>
      <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
        <img className="w-20 mx-auto mt-4 mb-2" src={JavaScript} alt="HTML icon" />
        <p className="text-lg">JAVASCRIPT</p>
      </div>
      <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
        <img className="w-20 mx-auto mt-4 mb-2" src={cpp} alt="HTML icon" />
        <p className="text-lg">C++</p>
      </div>
      <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
        <img className="w-20 mx-auto mt-4 mb-2" src={c} alt="C icon" />
        <p className="text-lg">C</p>
      </div>
      <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
        <img className="w-20 mx-auto mt-4 mb-2" src={Node} alt="HTML icon" />
        <p className="text-lg">NODE.JS</p>
      </div>
      <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
        <img className="w-20 mx-auto mt-4 mb-2" src={express} alt="HTML icon" />
        <p className="text-lg">EXPRESS.JS</p>
      </div>
      <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
        <img className="w-20 mx-auto mt-4 mb-2" src={Mongo} alt="HTML icon" />
        <p className="text-lg">MONGO DB</p>
      </div>
      <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
        <img className="w-20 mx-auto mt-4 mb-2" src={ReactImg} alt="HTML icon" />
        <p className="text-lg">REACT.JS</p>
      </div>
      <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
        <img className="w-20 mx-auto mt-4 mb-2" src={ejs} alt="HTML icon" />
        <p className="text-lg">EJS</p>
      </div>
      <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
        <img className="w-20 mx-auto mt-4 mb-2" src={redux} alt="HTML icon" />
        <p className="text-lg">REDUX</p>
      </div>
      <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
        <img className="w-20 mx-auto mt-4 mb-2" src={HTML} alt="HTML icon" />
        <p className="text-lg">HTML</p>
      </div>
      <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
        <img className="w-20 mx-auto mt-4 mb-2" src={CSS} alt="HTML icon" />
        <p className="text-lg">CSS</p>
      </div>
      <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
        <img className="w-20 mx-auto mt-4 mb-2" src={bootstrap} alt="HTML icon" />
        <p className="text-lg">BOOTSTRAP</p>
      </div>
      <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
        <img className="w-20 mx-auto mt-4 mb-2" src={antd} alt="HTML icon" />
        <p className="text-lg">ANTD</p>
      </div>
      <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
        <img className="w-20 mx-auto mt-4 mb-2" src={Tailwind} alt="HTML icon" />
        <p className="text-lg">TAILWIND CSS</p>
      </div>
      <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
        <img className="w-20 mx-auto mt-4 mb-2" src={mui} alt="HTML icon" />
        <p className="text-lg">MATERIAL UI</p>
      </div>
      <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
        <img className="w-20 mx-auto mt-4 mb-2" src={unix} alt="HTML icon" />
        <p className="text-lg">UNIX</p>
      </div>
      <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
        <img className="w-20 mx-auto mt-4 mb-2" src={git} alt="HTML icon" />
        <p className="text-lg">GIT</p>
      </div>
      <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
        <img className="w-20 mx-auto mt-4 mb-2" src={GitHub} alt="HTML icon" />
        <p className="text-lg">GITHUB</p>
      </div>
      <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
      <img className="w-20 mx-auto mt-4 mb-2" src={Figma} alt="HTML icon" />
        <p className="text-lg">FIGMA</p>
      </div>
      <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
      <img className="w-20 mx-auto mt-4 mb-2" src={authh} alt="HTML icon" />
        <p className="text-lg">AUTHENTICATION AND AUTHORIZATION</p>
      </div>
      <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
      <img className="w-20 mx-auto mt-4 mb-2" src={oauth} alt="HTML icon" />
        <p className="text-lg">OAUTH</p>
      </div>
      <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
      <img className="w-20 mx-auto mt-4 mb-2" src={jwt} alt="HTML icon" />
        <p className="text-lg">JSON WEB TOKEN</p>
      </div>
      <div className="shadow-md shadow-[#040c16] hover:scale-110 duration-500">
      <img className="w-20 mx-auto mt-4 mb-2" src={passport} alt="HTML icon" />
        <p className="text-lg">PASSPORT.JS</p>
      </div>
    </div>
  </div>
</div>
  );
};

export default Skills;
